import React, { useContext, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Link } from 'react-router-dom';
import GlobalContext from '../context/store';

function LandingSlider() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { setShowBooking } = useContext(GlobalContext)
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ paddingTop: '0 !important' }} className="yscott-homepage-section">
      <div className="container">
        <div style={{
          position: 'relative',
          width: '100%',
          height: '100vh',
          overflow: 'hidden',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50%',
          margin: '0 auto',
          // textAlign: 'center',
          zIndex: 100,
        }}>

          <Swiper
            modules={[Autoplay]}
            allowSlideNext={true}
            allowSlidePrev={true}
            pagination={false}
            centeredSlides={true}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            style={{ width: '100%', height: '100%', overflow: 'hidden' }} // Ensure full width and correct overflow
            className="swiper-container"
          >
            <SwiperSlide style={{ width: '100%', height: '100%' }}>
              <div style={{
                backgroundImage: `url('https://dollhousemermaid.s3.us-west-1.amazonaws.com/img/2.jpeg')`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: windowWidth > 768 ? 'left' : 'center',
                width: '100%',
                height: '100%',
                position: 'relative',
              }}></div>
            </SwiperSlide>
            <SwiperSlide style={{ width: '100%', height: '100%' }}>
              <div style={{
                backgroundImage: `url('https://dollhousemermaid.s3.us-west-1.amazonaws.com/img/3.jpeg')`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: windowWidth > 768 ? 'left' : 'center',
                width: '100%',
                height: '100%',
                position: 'relative',
              }}></div>
            </SwiperSlide>
            <SwiperSlide style={{ width: '100%', height: '100%' }}>
              <div style={{
                backgroundImage: `url('https://dollhousemermaid.s3.us-west-1.amazonaws.com/img/6.jpeg')`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: windowWidth > 768 ? 'left' : 'center',
                width: '100%',
                height: '100%',
                position: 'relative',
              }}></div>
            </SwiperSlide>

            <SwiperSlide style={{ width: '100%', height: '100%' }}>
              <div style={{
                backgroundImage: `url('https://dollhousemermaid.s3.us-west-1.amazonaws.com/img/2.jpeg')`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: windowWidth > 768 ? 'left' : 'center',
                width: '100%',
                height: '100%',
                position: 'relative',
              }}></div>
            </SwiperSlide>
            <SwiperSlide style={{ width: '100%', height: '100%' }}>
              <div style={{
                backgroundImage: `url('https://dollhousemermaid.s3.us-west-1.amazonaws.com/img/3.jpeg')`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: windowWidth > 768 ? 'left' : 'center',
                width: '100%',
                height: '100%',
                position: 'relative',
              }}></div>
            </SwiperSlide>
            <SwiperSlide style={{ width: '100%', height: '100%' }}>
              <div style={{
                backgroundImage: `url('https://dollhousemermaid.s3.us-west-1.amazonaws.com/img/6.jpeg')`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: windowWidth > 768 ? 'left' : 'center',
                width: '100%',
                height: '100%',
                position: 'relative',
              }}></div>
            </SwiperSlide>


          </Swiper>

          <div style={{ zIndex: 999 }} className="yscott-view-on-mobile">
            <h1>Viki Diaz</h1>
            <p style={{ textAlign: 'center' }} className="yscott-p-subtitle">Makeup Artist</p>
          </div>

          <div style={{
            position: 'absolute',
            top: windowWidth > 768 ? '50%' : '90%',
            left: windowWidth > 768 ? '85%' : '45%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: 'white',
            width: windowWidth > 768 ? '75%' : '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
            paddingBottom: '100px',
          }}>
            <div className="yscott-content-absolute yscott-content-absolute-right">
              <div className="yscott-not-view-on-mobile">
                <h1>Viki Diaz</h1>
                <p style={{ textAlign: 'center' }} className="yscott-p-subtitle">Makeup Artist</p>
              </div>
              <div
                className=""
                style={{
                  display: windowWidth > 768 ? 'block' : 'flex',
                  justifyContent: windowWidth > 768 ? undefined : 'center',
                  marginLeft: windowWidth > 768 ? undefined : '20px',
                  width: '100%',
                }}
              >
                
              </div>
              <p
                style={{
                  width: windowWidth > 749 ? '80%' : '90%',
                  marginLeft: '10%',
                  marginTop: windowWidth > 768 ? undefined : '10px',
                  marginBottom: windowWidth > 768 ? undefined : '18px',
                }}
                className="text yscott-text-home"
              >
                <p
                  style={{
                    textTransform: 'uppercase',
                    letterSpacing: '0.12em',
                    fontWeight: 'bolder',
                    fontSize: windowWidth > 768 ? '18px' : '15px',
                    color: '#000',
                    fontStyle: 'normal',
                    textAlign: 'center',
                    margin: windowWidth > 768 ? '12px 0 10px' : '8px 0 6px',
                    padding: windowWidth > 768 ? '6px 1px' : '10px 0px',
                    display: 'inline-block',
                    width: windowWidth > 768 ? '70%' : '92%',
                    maxWidth: '520px',
                    
                  }}
                >
                  Luxury Makeup Artist
                </p>
                <br />
                Timeless & elevated glam. Created to enhance natural beauty & empower life’s iconic moments.
              </p>
            </div>
            <div style={{ marginLeft: windowWidth > 749 ? '-50%' : '10%', backgroundColor: windowWidth > 749 ? 'transparent' : '#edd5cf', marginTop: windowWidth > 768 ? 0 : 0 }} className="yscott-color-button">
              <div className="yscott-button-link"> <Link onClick={() => setShowBooking(true)}> Book Glam</Link> <span className="yscott-button-block yscott-button-block-grey"></span> </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingSlider